import ULThemeSubtitle from "@/components/ULThemeSubtitle";
import ULThemeTitle from "@/components/ULThemeTitle";

import { useMfaOtpChallengeManager } from "../hooks/useMfaOtpChallengeManager";

function Header() {
  const { texts, locales } = useMfaOtpChallengeManager();

  // ⚠️ COPY MUST SUIT BOTH MOMENTS THIS SCREEN SERVES — see index.tsx. It is
  // shown both for the ordinary login-time OTP challenge and for the
  // beneficiaries step-up, and the screen has no way to tell them apart. So
  // it says "Verify your identity" rather than anything that names a section
  // or implies a particular reason.
  const title = texts?.title || locales?.header?.title;
  const description = texts?.description || locales?.header?.description;

  return (
    <>
      <ULThemeTitle>{title}</ULThemeTitle>
      <ULThemeSubtitle className="mb-1">{description}</ULThemeSubtitle>
      <p className="text-xs mb-6" style={{ color: "#6B7280" }}>
        {locales?.header?.hint}
      </p>
    </>
  );
}

export default Header;
